<div class="settings-modal-content">
  <h2 class="mat-h2">Account Region</h2>
  <div>
    <h3 class="my-4">Add new:</h3>
    <app-account-region-item [regionData]="newRegionData" [showDeleteRegion]="false"></app-account-region-item>
    <button mat-flat-button color="primary" (click)="add()" [disabled]="!addAvailable()"><span>Add</span></button>
  </div>
  <div *ngIf="getRegions().length > 0">
    <h3 class="my-4">Existing regions:</h3>
    <div *ngFor="let region of getRegions()">
      <app-account-region-item [regionData]="region" (onDeleteRegion)="remove($event)" [showBudgets]="true" [showDeleteRegion]="true"></app-account-region-item>
    </div>
  </div>
  <br><br>
</div>
